module.exports = __webpack_public_path__ + "img/scatter.8a045c51.png";